var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitechain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.05263C0 2.26214 2.26214 0 5.05262 0H14.2105C15.626 0 16.9055 0.582058 17.8228 1.51988L17.823 1.51966L22.7007 6.39736L22.6961 6.40192C21.7715 5.37905 20.4342 4.73633 18.9468 4.73633H9.78895C6.99846 4.73633 4.73633 6.99847 4.73633 9.78896V18.9468C4.73633 20.2518 5.231 21.4411 6.04306 22.3377L1.66189 17.9565C0.641172 17.032 0 15.6961 0 14.2105V5.05263ZM6.39813 22.6927L6.40174 22.6964L6.40192 22.6962C6.40066 22.695 6.39939 22.6939 6.39813 22.6927Z",
    fill: "#408FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2627 4.74609V15.1574C19.2627 17.4247 17.4247 19.2627 15.1574 19.2627H4.74609C4.9091 21.9061 7.10458 23.9995 9.78901 23.9995H18.9469C21.7374 23.9995 23.9995 21.7374 23.9995 18.9469V9.78902C23.9995 7.10458 21.9061 4.9091 19.2627 4.74609ZM9.71723 14.283C8.12819 12.6939 8.12819 10.1164 9.71723 8.5274L15.4728 14.283C13.8838 15.872 11.3063 15.872 9.71723 14.283Z",
    fill: "#408FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitechain);
export default __webpack_public_path__ + "static/media/whitechain.16599225.svg";
export { ForwardRef as ReactComponent };